import { motion } from "framer-motion";
import ShareButtons from "../../../utility/ShareButtons";
import FAQAccordion from "../../../utility/FAQAccordion";
import QuickNavigation from "../../../utility/serviceTemplateutility/QuickNavigation";
import CardDesign from "../../../utility/serviceTemplateutility/CardDesign";
import ListDesign from "../../../utility/serviceTemplateutility/ListDesign";
import WhyUs from "../../../utility/serviceTemplateutility/WhyUs";
import OurTeam from "../../homepage/OurTeam";
import Testimonials from "../../homepage/Testimonials";
import { useGlobalData } from "../../../contextApi/globalContextData";
import { useCart } from "../../../contextApi/cartContext";
import MultiStepForm from "../../../utility/serviceTemplateutility/MultiStepForm";
import { useLanguage } from "../../../contextApi/languageContext";
import { ivdrips } from "../../../text-files/homecare/ivdrips.ts";
// import useServiceData from "../../../utility/useServiceData";

const IVDrops = () => {
  const serviceUrl = window.location.href;
  const { sectionsData } = useGlobalData();
  const { addToCart } = useCart();
  const { language } = useLanguage();
  const content = ivdrips[language];
  const shared = ivdrips.shared;

  const product = {
    id: 1,
    title: "IV Drips at Home",
    price: 599,
    description:
      "Get hydration, vitamins, and energy-boosting nutrients delivered by professionals to your home—convenient wellness without clinic visits.",
  };

  const faqData = [
    { heading: "Frequently Asked Questions" },
    {
      question: "Is IV drip therapy at home safe?",
      answer:
        "Yes, IV drip therapy at home is safe when performed by certified healthcare professionals. In Dubai, licensed nurses or doctors administer the treatment, ensuring proper sterilization and protocol adherence.",
    },
    {
      question: "How long does an IV drip session last?",
      answer:
        "An IV drip session typically lasts between 30 to 60 minutes, depending on the type of infusion and your health needs.",
    },
    {
      question: "What types of IV drips are available?",
      answer:
        "There are various formulations available, including hydration drips, immune-boosting drips, energy boosters, anti-aging drips, and drips tailored to alleviate jet lag, migraines, or hangovers.",
    },
    {
      question: "How often can I get IV drip therapy?",
      answer:
        "The frequency of your sessions depends on your health goals and the recommendation of your healthcare provider. Some people opt for weekly sessions, while others may choose monthly treatments.",
    },
    {
      question: "Can everyone use IV therapy?",
      answer:
        "IV therapy is safe for most people, but a healthcare provider will assess your eligibility based on your medical history and current health status. Those with certain medical conditions or allergies should consult with their doctor before starting IV therapy.",
    },
  ];

  const benefits = [
    { heading: "Benefits of IV Drip Infusion" },
    {
      para: "Opting for IV drip home service Dubai brings several key health and convenience benefits, making it a top choice for busy professionals and those who value privacy.",
    },
    {
      title: "Hydration Boost",
      description:
        "Replenishes your body’s hydration levels, ideal for post-exercise recovery or combating Dubai’s hot climate.",
      icon: "fa-solid fa-tint",
    },
    {
      title: "Energy Enhancement",
      description:
        "Helps fight fatigue by delivering essential vitamins like B12 directly into your bloodstream.",
      icon: "fa-solid fa-bolt",
    },
    {
      title: "Immune System Support",
      description:
        "Strengthens your immunity with vitamin C, zinc, and other antioxidants, reducing the likelihood of illnesses.",
      icon: "fa-solid fa-shield-virus",
    },
    {
      title: "Customized Treatments",
      description:
        "Formulas can be tailored to address your specific needs, such as anti-aging, stress relief, or improving mental clarity.",
      icon: "fa-solid fa-cogs",
    },
    {
      title: "Fast Recovery",
      description:
        "Ideal for hangovers, jet lag, or illnesses, IV therapy delivers instant relief and quicker recovery.",
      icon: "fa-solid fa-medkit",
    },
    {
      title: "Ultimate Convenience",
      description:
        "No need to travel, professionals come to your doorstep, saving time and effort.",
      icon: "fa-solid fa-truck",
    },
  ];

  const procedureSteps = [
    { heading: "Procedures" },
    {
      title: "Consultation",
      description:
        "Give us a call, one of our dedicated agents will assist you promptly.",
      icon: "fa-solid fa-phone",
    },
    {
      title: "Preparation",
      description:
        "DHA certified nurse arrives at your home with all the necessary equipment.",
      icon: "fa-solid fa-kit-medical",
    },
    {
      title: "Administration",
      description:
        "The IV drip is carefully inserted into your vein, and the nutrient-rich solution is infused over a 30–60-minute session.",
      icon: "fa-solid fa-syringe",
    },
    {
      title: "Relax & Rejuvenate",
      description:
        "You can relax in your own space while a professional ensures a smooth and monitored experience.",
      icon: "fa-solid fa-bed",
    },
  ];

  const idealCandidates = [
    { text: "Those feeling fatigued or low on energy." },
    { text: "Individuals needing immune support." },
    { text: "People seeking hydration or hangover recovery." },
    { text: "Athletes needing faster recovery or muscle repair." },
    { text: "Frequent travelers or those with jet lag." },
    { text: "Anyone with vitamin or nutrient deficiencies." },
    { text: "Individuals under stress or mental fatigue." },
  ];

  const preparationSteps = [
    { text: "Stay hydrated before the session." },
    { text: "Eat a light meal to avoid dizziness." },
    { text: "Avoid caffeine or alcohol before therapy." },
    { text: "Wear comfortable clothing for easy access to your arm." },
  ];

  return (
    <>
      <title>IV Drip at Home Service Dubai | Best IV Drip Dubai</title>
      <meta
        name="description"
        content="Convenient IV drip at home service in Dubai. Experience deep hydration, energy boosts, NAD+ Anti-Stress, hangover IV drip, and recovery benefits, all delivered to your doorstep by skilled professionals for a seamless wellness experience."
      />
      <meta
        name="robots"
        content="follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large"
      />
      <link
        rel="canonical"
        href="https://elitebodyhome.com/services/services/iv-drip-at-home-dubai/"
      />
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="article" />
      <meta
        property="og:title"
        content="IV Drip at Home Service Dubai | Best IV Drip Dubai"
      />
      <meta
        property="og:description"
        content="Convenient IV drip at home service in Dubai. Experience deep hydration, energy boosts, NAD+ Anti-Stress, hangover IV drip, and recovery benefits, all delivered to your doorstep by skilled professionals for a seamless wellness experience."
      />
      <meta
        property="og:url"
        content="https://elitebodyhome.com/services/iv-drip-at-home-dubai/"
      />
      <meta property="og:site_name" content="elitebodyhome.com" />
      <meta property="og:updated_time" content="2025-02-15T14:26:57+00:00" />
      <meta
        property="og:image"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-88.jpg"
      />
      <meta
        property="og:image:secure_url"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-88.jpg"
      />
      <meta property="og:image:width" content="1254" />
      <meta property="og:image:height" content="700" />
      <meta property="og:image:alt" content="iv drip at home" />
      <meta property="og:image:type" content="image/jpeg" />
      <meta
        property="og:video"
        content="https://www.youtube.com/embed/jBK099N4aCI"
      />
      <meta property="video:duration" content="90" />
      <meta property="ya:ovs:upload_date" content="2024-07-25T09:46:12-07:00" />
      <meta property="ya:ovs:allow_embed" content="true" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="IV Drip at Home Service Dubai | Best IV Drip Dubai"
      />
      <meta
        name="twitter:description"
        content="Convenient IV drip at home service in Dubai. Experience deep hydration, energy boosts, NAD+ Anti-Stress, hangover IV drip, and recovery benefits, all delivered to your doorstep by skilled professionals for a seamless wellness experience."
      />
      <meta
        name="twitter:image"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-88.jpg"
      />
      <div
        className="min-vh-100 font-sans text-dark  mb-5 mx-3"
        dir={language === "ar" ? "rtl" : "ltr"}
      >
        <div className="container-fluid px-0 py-4">
          <div className="row justify-content-center">
            <div>
              <div
                className="rounded-4 overflow-hidden shadow-sm"
                style={{ border: "2px solid #c69933" }}
              >
                <div className="row g-0 align-items-stretch">
                  {/* Image Column - Left Side */}
                  <div className="col-lg-6">
                    <img
                      loading="lazy"
                      decoding="async"
                      src={shared.images.main}
                      className="img-fluid w-100 h-100 object-fit-cover"
                      alt="IV drip Dubai | Elite Body Home"
                      style={{
                        minHeight: "400px",
                        maxHeight: "720px",
                      }}
                    />
                  </div>

                  {/* Content Column - Right Side */}
                  <div className="col-lg-6 d-flex align-items-center bg-white">
                    {language === "en" ? (
                      <div
                        className="p-4 p-md-5 w-100"
                        style={{ maxWidth: "600px", margin: "0 auto" }}
                      >
                        <h1
                          className="display-5 fw-bold mb-3"
                          style={{
                            color: "#c69933",
                          }}
                        >
                          IV Drip Dubai
                        </h1>
                      </div>
                    ) : (
                      <div
                        className="p-4 p-md-5 w-100"
                        style={{ maxWidth: "600px", margin: "0 auto" }}
                      >
                        <h1
                          className="display-5 fw-bold mb-3"
                          style={{
                            color: "#c69933",
                          }}
                        >
                          الحقن الوريدي في دبي
                        </h1>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex gap-4  w-100 ">
          <div
            className=" rounded-4 p-2 bg-white flex-grow-1 "
            style={{
              width: "65%",
              border: "2px solid #c69933",
            }}
          >
            <nav aria-label="breadcrumb" className="p-2">
              <ol className="breadcrumb">
                {content.breadcrumbs.map((item, index) => (
                  <li
                    key={index}
                    className={`breadcrumb-item ${
                      index === content.breadcrumbs.length - 1 ? "active" : ""
                    }`}
                    aria-current={
                      index === content.breadcrumbs.length - 1
                        ? "page"
                        : undefined
                    }
                  >
                    {index === content.breadcrumbs.length - 1 ? (
                      item
                    ) : (
                      <a href={index === 0 ? "/home" : "#"}>{item}</a>
                    )}
                  </li>
                ))}
              </ol>
            </nav>
            <div className="text-center my-2">
              <motion.h1
                className="display-4 fw-bold"
                style={{ color: "#c69933" }}
              >
                {content.hero.title}
              </motion.h1>

              {content.hero.subtitle && (
                <motion.h2 className="fw-semibold mt-3">
                  {content.hero.subtitle}
                </motion.h2>
              )}

              {content.hero.description && (
                <motion.p className="lead mt-3">
                  {content.hero.description}
                </motion.p>
              )}
            </div>
            <QuickNavigation />
            <section id="process" className="my-5">
              <CardDesign carditems={content.procedureSteps} />
            </section>

            {/* Benefits Section */}
            <section id="benefits" className="my-5">
              <ListDesign listitems={content.benefits} />
            </section>

            <section id="process" className="my-5">
              <ListDesign listitems={content.ingredients} />
            </section>

            {/* Eligibility Section */}
            <section id="eligibility" className="my-5">
              <CardDesign listitems={content.eligibility} />
            </section>

            {/* Preparation Section */}
            <section id="preparations" className="my-5">
              <ListDesign listitems={content.preparationTips} />
            </section>

            {/* Results Section */}
            <section id="results" className="my-5">
              <ListDesign listitems={content.results} />
            </section>

            {/* Aftercare Section */}
            <section className="my-5">
              <ListDesign listitems={content.aftercareTips} />
            </section>

            {/* Product Card */}
            {shared.images.main && (
              <motion.div
                className="my-5"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
              >
                <div
                  className="card border-0 shadow-lg rounded-4 overflow-hidden mx-auto"
                  style={{ maxWidth: "420px" }}
                >
                  <img
                    src={shared.images.main}
                    alt={content.meta.title}
                    className="card-img-top"
                    style={{ height: "280px", objectFit: "cover" }}
                  />
                  <div className="card-body text-center px-4 py-4">
                    <h5 className="card-title fw-bold text-uppercase text-dark mb-2">
                      {content.meta.title}
                    </h5>
                    <p className="card-text text-muted small">
                      {content.meta.description}
                    </p>
                    {/* <h6
                        className="text-success fw-bold mt-3"
                        style={{ fontSize: "1.1rem" }}
                      >
                        {language === "en" ? "Price" : "السعر"}: AED{" "}
                        {shared.product.price}
                      </h6> */}
                    <button
                      className="btn rounded-pill px-4 py-2 mt-3 text-white fw-bold"
                      style={{
                        background: "#c69933",
                        border: "2px solid #c69933",
                      }}
                      onClick={() =>
                        addToCart({
                          ...shared.product,
                          image: shared.images.main,
                        })
                      }
                    >
                      {language === "en" ? "Add to Cart" : "أضف إلى السلة"}
                    </button>
                  </div>
                </div>
              </motion.div>
            )}
            <WhyUs language={language} />
            <OurTeam data={sectionsData["Professional"]} />
            <Testimonials
              data={sectionsData["Success Stories"]}
              language={language}
            />
            <FAQAccordion faqData={content.faqData} />
            <ShareButtons url={serviceUrl} />
          </div>
          <MultiStepForm />
        </div>
      </div>
    </>
  );
};

export default IVDrops;
